import { Navigate } from "react-router-dom";
import { useSession } from "../../hooks/useSession";

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: me, isLoading, error } = useSession();

  if (isLoading) {
    return <div className="flex h-full items-center justify-center text-slate-500">Loading…</div>;
  }
  if (error || !me) return <Navigate to="/login" replace />;
  if (me.status !== "APPROVED") return <Navigate to="/pending-approval" replace />;

  return <>{children}</>;
}
